import { render } from "./CurrencyTicker.vue?vue&type=template&id=b2b6701c&scoped=true"
import script from "./CurrencyTicker.vue?vue&type=script&lang=js"
export * from "./CurrencyTicker.vue?vue&type=script&lang=js"

import "./CurrencyTicker.vue?vue&type=style&index=0&id=b2b6701c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b6701c"]])

export default __exports__